<template>
  <div>
    <div class="text-center">
      <h2
        class="text-2xl tracking-wider leading-10 font-extrabold font-bebas text-peach mt-4 sm:text-5xl sm:leading-none md:text-4xl"
      >
        Show &amp; Tell
      </h2>
    </div>
    <div>
      <div class="">
        <div
          v-if="loggedIn"
          class="max-w-screen-xl mx-auto text-center py-12 px-4 sm:px-6 lg:py-16 lg:px-8"
        >
          <h2
            class="text-2xl leading-9 font-semibold tracking-tight text-darkpurple sm:text-4xl sm:leading-10"
          >
            Share your project
            <br />
          </h2>
          <div class="mt-8 flex justify-center">
            <div class="inline-flex rounded-md shadow">
              <router-link to="/share">
                <a
                  href="#"
                  class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-xl font-bebas tracking-wider
                   leading-6 font-medium rounded-md text-white bg-darkpurple hover:bg-peach focus:outline-none focus:shadow-outline
                  transition duration-150 ease-in-out"
                >
                  Share Now
                </a>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ul
      class="sm:grid sm:grid-cols-2 sm:col-gap-6 lg:grid-cols-3 lg:col-gap-8 gap-6 mt-6"
    >
      <li v-for="proj in projects" :key="proj._id">
        <router-link :to="projectUrl(proj._id)">
          <div
            class="bg-light-paper shadow hover:shadow-2xl transform hover:scale-105 cursor-pointer"
          >
            <div class="relative pb-2/3 overflow-hidden">
              <img
                class="absolute object-center w-full min-w-full min-h-full "
                :src="proj.projectPhotos[0]"
                alt=""
              />
            </div>

            <div class="space-y-2">
              <div
                class="p-4 font-bebas text-darkpurple tracking-wide text-2xl text-center"
              >
                {{ proj.projectTitle }}
              </div>
            </div>
          </div>
        </router-link>
      </li>

      <!-- More people... -->
    </ul>
    <if-can-take-part message="Log in to share your project"></if-can-take-part>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { sanityClient } from "../utils/sanity";

export default {
  name: "MarketingProjects",
  data() {
    return {
      projects: [],
      subscription: null
    };
  },
  computed: {
    ...mapGetters(["loggedIn"])
  },
  methods: {
    projectUrl(id) {
      return "/project/" + id;
    },
    fetchProjects() {
      const queryString =
        "*[_type == 'userProject' && allowMarketing == true && !(_id in path('drafts.**'))]{...}";
      sanityClient
        .fetch(queryString)
        .then(res => {
          this.projects = res;
        })
        .catch(function(err) {
          console.warn(err);
        });
    }
  },
  created() {
    // this.subscription = this.subscribe();
    this.fetchProjects();
  },
  beforeDestroy() {
    if (this.subscription != null) {
      this.subscription.unsubscribe();
    }
  }
};
</script>

<style scoped></style>
